import React, { Component } from 'react'
import i18next from 'i18next'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container-sm text-center">
          <h3 className="text-danger">{i18next.t('views.pages.error_boundary.error_occurred')}</h3>
          <p>{i18next.t('views.pages.error_boundary.contact_support')}</p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
